import { Injectable } from "@angular/core";
import { Observable, of, Subject } from "rxjs";
import { map } from "rxjs/operators";
import { HttpService } from "src/app/session/services/http.service";
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: "root",
})
export class ReportsService {
  inspectionReportGenerated: Subject<boolean> = new Subject<boolean>();

  constructor(private httpService: HttpService) {}

  generateReport(
    inspectionId: string,
    isPdf: boolean,
    templateId: string = null,
    itemsId: string[] = [],
    emailsToSend: string[] = [],
  ): Promise<void> {
    const reportToSend = {
      inspectionId,
      itemsId,
      templateId,
      isPdf,
      destinationEmails: emailsToSend,
    };
    return this.httpService
      .post(
        `${environment.webApiUrl}/api/reports/generate-report`,
        reportToSend,
        { withCredentials: true },
      )
      .toPromise();
  }

  generateReportBasedOnCode(
    inspectionId: string,
    isPdf: boolean,
    templateId: string,
    itemsId: string[],
    emailsToSend: string[],
  ): Promise<void> {
    const reportToSend = {
      inspectionId,
      templateId,
      itemsId,
      isPdf,
      destinationEmails: emailsToSend,
    };
    return this.httpService
      .post(`${environment.webApiUrl}/api/reportsBasedOnCode`, reportToSend, {
        withCredentials: true,
      })
      .toPromise();
  }
}
